import React, { useEffect } from 'react';

export default function SocialJuiceWall() {
  useEffect(() => {
    // Dynamically load the iFrameResizer script
    const script = document.createElement('script');
    script.src = "https://embed.socialjuice.io/js/iframeResizer.min.js";
    script.async = true;
    
    script.onload = () => {
      // Initialize the resizer once the script is loaded
      if (window.iFrameResize) {
        window.iFrameResize(
          { log: false, checkOrigin: false },
          "#socialjuice-wall-otso-co-5403"
        );
      }
    };

    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="w-full max-w-6xl mx-auto">
      <iframe
        id="socialjuice-wall-otso-co-5403"
        src="https://embed.socialjuice.io/wall/7473?s=otso-co"
        allowFullScreen
        allowTransparency="true"
        frameBorder="0"
        scrolling="no"
        width="100%"
        height="575px"
        title="Customer Testimonials"
        className="border-none w-full"
      ></iframe>
    </div>
  );
}